import React from 'react';
export function Chrome({ nonce, children }) {
    return (React.createElement("div", { id: "__chrome", style: { display: 'contents' } },
        React.createElement("template", { shadowrootmode: "open", dangerouslySetInnerHTML: {
                __html: `
            <!--# include virtual="/api/chrome?nonce=${encodeURIComponent(nonce)}" set="chrome" -->
      <!--# if expr="$chrome" -->
      <!--# echo var="chrome" encoding="none" -->
      <!--# else -->
      <script src="/api/chromefallback?nonce=${encodeURIComponent(nonce)}" nonce="${nonce}" async></script>
      <!--# endif -->`,
            } }),
        React.createElement("script", { nonce: nonce, dangerouslySetInnerHTML: {
                __html: `
(function attachShadowRoots(root) {
  root.querySelectorAll("template[shadowrootmode]").forEach(template => {
    const mode = template.getAttribute("shadowrootmode");
    const shadowRoot = template.parentNode.attachShadow({ mode });
    shadowRoot.appendChild(template.content);
    template.remove();
    attachShadowRoots(shadowRoot);
  });
})(document);
      `,
            } }),
        children));
}
//# sourceMappingURL=Chrome.js.map